module.exports = __webpack_public_path__ + "img/mitsubishi.afb62318.png";